import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
export const useLocalHuddleUpdate = () => {
    const queryClient = useQueryClient();
    const mutate = useCallback((data, onSuccess) => {
        let prevDoc;
        queryClient.setQueryData([CacheKeys.HUDDLE, data.id], (prev) => {
            prevDoc = prev;
            return data;
        });
        if (onSuccess)
            onSuccess(data, prevDoc);
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalHuddleUpdate.js.map